import { render, staticRenderFns } from "./resumenDeAdeudos.vue?vue&type=template&id=57b78ef0&scoped=true&"
import script from "./resumenDeAdeudos.vue?vue&type=script&lang=js&"
export * from "./resumenDeAdeudos.vue?vue&type=script&lang=js&"
import style0 from "./resumenDeAdeudos.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./resumenDeAdeudos.vue?vue&type=style&index=1&id=57b78ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b78ef0",
  null
  
)

export default component.exports